/*** IMPORTS FROM imports-loader ***/
(function() {
var app = window.app||{};
var define = false;
var exports = false;
var module = undefined;

/*** IMPORTS FROM imports-loader ***/
(function() {
var app = window.app||{};
var define = false;
var exports = false;
var module = undefined;

var app = app || {};

(function () {
  'use strict';
  
  /**
   * Вид для видео на странице Колориста
   */
  app.ColloristaVideoView = app.BaseVideoView.extend({
    el: '',
    events: {
      'click .control-play': 'play'
    },
        
    render: function () {
      this.initPlayer();
    },
    
    play: function () {
      if (this.player) {
        this.$('.video-preview').addClass('not_display');
        this.player.play();
      }
    }
  });
})();

}.call(window));
}.call(window));